var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 0.5,
    y: 1.35059,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#141BEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_4402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0605 13.8662H13.9766C11.802 13.8662 10.0391 15.5704 10.0391 17.6725V23.0287C10.0391 25.1309 11.802 26.835 13.9766 26.835H25.0605C27.2351 26.835 28.998 25.1309 28.998 23.0287V17.6725C28.998 15.5704 27.2351 13.8662 25.0605 13.8662ZM22.3975 20.6112L17.2132 23.0014C17.0751 23.0651 16.9155 22.9678 16.9155 22.8198V17.89C16.9155 17.74 17.0793 17.6427 17.2177 17.7106L22.402 20.2502C22.5562 20.3257 22.5535 20.5393 22.3975 20.6112Z",
    fill: "#141BEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_4402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 13,
    fill: "white",
    transform: "translate(10 13.8506)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d6b3e3c9970744bfcd4e2259b6d826d3.svg";
export { ForwardRef as ReactComponent };